import React, { useState } from 'react'
import './how-used.scss'

import ModalSizes from '../../atoms/modal-sizes/modal-sizes'

import stepOne from '../../../assets/images/step-one.svg'
import stepTwo from '../../../assets/images/step-two.svg'
import stepThree from '../../../assets/images/step-three.svg'
import stepFour from '../../../assets/images/step-four.svg'

import { textChange } from '../../../constants/activity-constants'

const HowUsed = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="f-how-used">
        <div id="comolausas" className="f-how-used__ancla" />

        <div className="f-how-used__content">
          <h2 className="f-how-used__content-title">¿Cómo la usas?</h2>

          <p className="f-how-used__content-description">{textChange.text_8}</p>

          <div className="f-how-used__content-steps">
            <div className="f-how-used__content-steps-stars" />

            <div className="f-how-used__content-steps-step">
              <img src={stepOne} alt="icon-step-one" />
              <p>{textChange.text_9}</p>
            </div>
            <div className="f-how-used__content-steps-step">
              <img src={stepTwo} alt="icon-step-two" />
              <p>{textChange.text_10}</p>
            </div>
            <div className="f-how-used__content-steps-step">
              <img src={stepThree} alt="icon-step-three" />
              <p>{textChange.text_11}</p>
            </div>
            <div className="f-how-used__content-steps-step">
              <img src={stepFour} alt="icon-step-four" />
              <p>Desposita en la basura</p>
            </div>
          </div>

          <div className="f-how-used__content-sizes">
            <h3>TALLAS</h3>

            <div className="f-how-used__content-sizes-content">
              <p className="f-how-used__content-sizes-content-description">
                {textChange.text_7}
              </p>

              <div className="f-how-used__content-sizes-content-size">
                <div className="f-how-used__content-sizes-content-size-text">
                  <span>S</span>
                  <p>75cm-95cm cadera</p>
                </div>

                <div className="f-how-used__content-sizes-content-size-text">
                  <span>M</span>
                  <p>95cm-105cm cadera</p>
                </div>

                <div className="f-how-used__content-sizes-content-size-text">
                  <span>L/XL</span>
                  <p>105cm-115cm cadera</p>
                </div>
              </div>

              <button
                onClick={() => {
                  setShowModal(true)
                  try {
                    window.dataLayer.push({
                      event: 'ga_event',
                      category: 'ui :: landing :: como las usas',
                      action: 'click',
                      label: 'ver guia de tallas',
                      value: '',
                    })
                  } catch (error) {
                    console.log(error)
                  }
                }}
              >
                Ver guía de tallas
              </button>
            </div>
          </div>
        </div>
      </div>

      {showModal ? <ModalSizes setShowModal={setShowModal} /> : null}
    </>
  )
}

export default HowUsed
